"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[817],{

/***/ 6562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8757);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8728);






function BookNow(param) {
    let { uniqueIdentifier , type , id , buttonWide , hasLongTitle  } = param;
    const { locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common");
    if (!uniqueIdentifier) return null;
    const localeQueryStringValue = locale === "default" ? undefined : locale;
    const href = (0,utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .generateBookingURL */ ._2)({
        uniqueIdentifier,
        type,
        id,
        locale: localeQueryStringValue
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex items-center justify-center border border-primary-500 text-sm rounded-lg text-primary-text bg-primary-500 uppercase font-medium hover:bg-primary-300 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap", {
            "py-2 px-8": buttonWide
        }, {
            "py-3 px-5": !buttonWide
        }),
        children: hasLongTitle && t("global.booknow") || t("global.book")
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BookNow));


/***/ }),

/***/ 2132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);


function Card(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative p-4 rounded-lg border border-zinc-200",
        children: children
    });
}


/***/ }),

/***/ 4341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Service_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/BookNow/BookNow.tsx
var BookNow = __webpack_require__(6562);
// EXTERNAL MODULE: ./components/Cards/Card.tsx
var Card = __webpack_require__(2132);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(6631);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
;// CONCATENATED MODULE: ./components/Badges/Virtual.badge.tsx




function VirtualBadge() {
    const { t  } = (0,useTranslation/* default */.Z)("common");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "inline-flex items-center text-primary-500 text-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineVoiceChat */.I51, {
                className: "h-4 w-4 mr-1"
            }),
            t("sections.services.virtual")
        ]
    });
}
/* harmony default export */ var Virtual_badge = (/*#__PURE__*/(0,react.memo)(VirtualBadge));

// EXTERNAL MODULE: ./hooks/useReadmore.ts + 1 modules
var useReadmore = __webpack_require__(1123);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./components/Services/Service.card.tsx









const ServiceCard = (param)=>{
    let { id , title , description , hasVirtualBadge , imageUrl , duration , price , unavailableItems  } = param;
    const unavailableItem = (0,react.useMemo)(()=>{
        return unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.reduce((obj, cur)=>({
                ...obj,
                [cur]: true
            }), {});
    }, [
        unavailableItems
    ]);
    const [truncated, hasLimit] = (0,useReadmore/* default */.Z)(description || "", 320);
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const priceFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.currency.name
    });
    const showPrice = price === 0 && "Free" || priceFormatter.format(price);
    const hasDurationOrPrice = !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.duration) || !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.price);
    const hasDurationAndPrice = !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.duration) && !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.price);
    const isImageHidden = unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 sm:gap-8 items-start flex-col sm:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "font-medium text-lg mb-1",
                            children: title
                        }),
                        (hasVirtualBadge || hasDurationOrPrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline-flex items-center space-x-2",
                            children: [
                                hasVirtualBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Virtual_badge, {}),
                                hasDurationOrPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "bg-primary-50 px-2 py-1 rounded-md text-xs",
                                    children: [
                                        !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.duration) && "".concat(duration / 60, " min"),
                                        hasDurationAndPrice && " | ",
                                        !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.price) && "".concat(showPrice)
                                    ]
                                })
                            ]
                        }),
                        !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm mt-2 text-[#46474a] leading-6 break-word pre-line",
                            children: [
                                truncated,
                                hasLimit && " ..."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full sm:w-auto min-w-[9rem] max-w-none sm:max-w-[9rem] flex-none flex flex-col space-y-3 justify-end sm:pl-4",
                    children: [
                        !isImageHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative aspect-[1.6] sm:aspect-[1.18] overflow-hidden",
                            children: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "w-full h-full rounded-lg bg-gray-200 object-cover select-none",
                                src: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) || (0,utils/* resolvedPublicPath */.dO)("service-placeholder.svg"),
                                alt: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.alt) || title,
                                width: 300,
                                height: 254,
                                quality: 90,
                                loading: "lazy"
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 rounded-lg flex items-center justify-center bg-gray-200 text-gray-500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    className: "w-6 h-6",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 32 32",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "currentColor",
                                            d: "m3.002 26.763 1.853.796V14.728l-3.36 8.327a2.897 2.897 0 0 0 1.507 3.708Zm26.966-5.258L23.113 4.497a2.785 2.785 0 0 0-2.507-1.748 2.72 2.72 0 0 0-1.093.213L9.327 7.296a2.84 2.84 0 0 0-1.701 2.558c-.014.39.057.777.207 1.137l6.86 17.007a2.768 2.768 0 0 0 2.53 1.748c.365 0 .727-.073 1.065-.213L28.466 25.2a2.861 2.861 0 0 0 1.507-3.694h-.005Zm-12.723 5.4L10.387 9.91l10.164-4.318h.015l6.846 16.98-10.167 4.332Z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M14.635 12.907a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8.168 27.746a2.005 2.005 0 0 0 2 2h1.455l-3.455-8.34v6.34Z"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow/* default */.Z, {
                            uniqueIdentifier: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.widget.uniqueIdentifier,
                            type: "service",
                            id: id,
                            buttonWide: true
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Service_card = (/*#__PURE__*/(0,react.memo)(ServiceCard));


/***/ }),

/***/ 9817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Categorized_services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/lodash-es/groupBy.js
var groupBy = __webpack_require__(5213);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
// EXTERNAL MODULE: ./types/business.types.ts
var business_types = __webpack_require__(3345);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6789);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(7690);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(6631);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.tsx





function Accordion(param) {
    let { title , totalItems , defaultOpen =false , children  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const services = t("sections.services.accordion_label", {
        count: totalItems
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        defaultOpen: defaultOpen,
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                        className: "flex w-full items-center rounded-lg bg-primary-50 transition-colors space-x-2 md:space-x-3 py-4 px-5 pl-4 focus:outline-none focus-visible:ring focus-visible:ring-primary-300 focus-visible:ring-opacity-75 mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdArrowDropDown */.gwH, {
                                className: "".concat(open ? "rotate-180" : "", " h-6 w-6 md:h-8 md:w-8 transform transition-transform flex-none")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium truncate text-sm md:text-base",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "opacity-75 text-sm whitespace-nowrap",
                                children: [
                                    "(",
                                    services,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        as: react.Fragment,
                        enter: "transition duration-500 ease-out",
                        enterFrom: "transform opacity-0",
                        enterTo: "transform opacity-100",
                        leave: "transition duration-200 ease-out",
                        leaveFrom: "transform opacity-100",
                        leaveTo: "transform opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                            className: "pb-4",
                            children: children
                        })
                    })
                ]
            });
        }
    });
}

// EXTERNAL MODULE: ./components/Services/Service.card.tsx + 1 modules
var Service_card = __webpack_require__(4341);
// EXTERNAL MODULE: ./node_modules/lodash-es/sortBy.js + 4 modules
var sortBy = __webpack_require__(7518);
// EXTERNAL MODULE: ./node_modules/lodash-es/toLower.js
var toLower = __webpack_require__(4209);
// EXTERNAL MODULE: ./node_modules/lodash-es/values.js + 1 modules
var values = __webpack_require__(2642);
// EXTERNAL MODULE: ./node_modules/lodash-es/omit.js + 35 modules
var omit = __webpack_require__(6941);
// EXTERNAL MODULE: ./node_modules/lodash-es/map.js
var map = __webpack_require__(7457);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./containers/Services/Categorized.services.tsx










function ServicesCategorized(param) {
    let { services , sorting , serviceSettings  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const unavailableItems = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.settings.service.unavailableItems;
    const categorized = (0,react.useMemo)(()=>{
        const serviceItems = services.items;
        let sortedServices = [];
        switch(sorting){
            case business_types/* defaultServiceSorting.ALPHABETICALLY */.eb.ALPHABETICALLY:
            case business_types/* defaultServiceSorting.AVAILABILITY */.eb.AVAILABILITY:
                sortedServices = (0,sortBy/* default */.Z)(serviceItems, [
                    (offering)=>offering.name.toLowerCase()
                ]);
                break;
            case business_types/* defaultServiceSorting.CUSTOM */.eb.CUSTOM:
                let customOrder = [];
                try {
                    customOrder = serviceSettings ? JSON.parse(serviceSettings) : [];
                    customOrder = (0,sortBy/* default */.Z)(customOrder, "order");
                } catch (e) {
                    console.error("Error in sorting offerings settings", e);
                }
                sortedServices = (0,utils/* sortListByAnotherList */.vY)(serviceItems, customOrder);
                break;
            default:
                sortedServices = (0,sortBy/* default */.Z)(serviceItems, (0,toLower/* default */.Z)(sorting));
        }
        const uncategorizedGroupLabel = t("sections.services.others");
        const groupedItems = (0,groupBy/* default */.Z)(sortedServices, (v)=>{
            var _v_category;
            return ((_v_category = v.category) === null || _v_category === void 0 ? void 0 : _v_category.name) || uncategorizedGroupLabel;
        });
        const uncategorizedGroup = groupedItems[uncategorizedGroupLabel];
        if (uncategorizedGroup) {
            return [
                ...(0,values/* default */.Z)((0,omit/* default */.Z)(groupedItems, uncategorizedGroupLabel)),
                uncategorizedGroup
            ];
        } else {
            return (0,values/* default */.Z)(groupedItems);
        }
    }, [
        serviceSettings,
        services,
        sorting,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,map/* default */.Z)(categorized, (items, i)=>{
            var _items_, _items__category, _items_map;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                defaultOpen: i === 0,
                title: (items === null || items === void 0 ? void 0 : (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : (_items__category = _items_.category) === null || _items__category === void 0 ? void 0 : _items__category.name) || t("sections.services.others"),
                totalItems: items === null || items === void 0 ? void 0 : items.length,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-2 gap-4",
                    children: items === null || items === void 0 ? void 0 : (_items_map = items.map) === null || _items_map === void 0 ? void 0 : _items_map.call(items, (service)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Service_card/* default */.Z, {
                            id: service.id,
                            hasVirtualBadge: service.appointmentType === business_types/* AppointmentType.Virtual */.Vn.Virtual,
                            title: service.name,
                            description: service.description,
                            imageUrl: service.image,
                            duration: service.duration,
                            price: service.price,
                            unavailableItems: unavailableItems
                        }, service.id);
                    })
                })
            }, i);
        })
    });
}
/* harmony default export */ var Categorized_services = (/*#__PURE__*/(0,react.memo)(ServicesCategorized));


/***/ }),

/***/ 1123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useReadmore; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
;// CONCATENATED MODULE: ./utils/truncate.utils.ts
function truncate(text, options) {
    const { length , separator =" " , ellipsis ="..."  } = options;
    let truncatedText = text;
    // Truncate by word boundary
    if (truncatedText.length > length) {
        const words = truncatedText.split(separator);
        let truncatedWords = words.slice(0, Math.max(1, words.length - 1));
        while(truncatedWords.join(separator).length + ellipsis.length > length){
            truncatedWords.pop();
        }
        truncatedText = truncatedWords.join(separator) + ellipsis;
    }
    return truncatedText;
}
/* harmony default export */ var truncate_utils = (truncate);

;// CONCATENATED MODULE: ./hooks/useReadmore.ts



function useReadMore(text) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 170;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const [isReadMore, setIsReadMore] = (0,react.useState)(false);
    const hasLimit = text.length > limit;
    const truncatedText = truncate_utils(text, {
        length: limit,
        separator: " ",
        ellipsis: ""
    });
    const description = isReadMore ? text : truncatedText;
    const helperText = isReadMore ? t("global.showless") : t("global.showmore");
    const onClickButton = ()=>setIsReadMore((prevState)=>!prevState);
    return [
        description,
        hasLimit,
        helperText,
        onClickButton,
        isReadMore
    ];
}
/* harmony default export */ var useReadmore = (useReadMore);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; },
/* harmony export */   "vY": function() { return /* binding */ sortListByAnotherList; }
/* harmony export */ });
/* unused harmony export isProd */
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(194);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3488);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6031);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(394);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4035);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(776);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7457);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4237);




const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    const link = query_string__WEBPACK_IMPORTED_MODULE_0__/* ["default"].stringifyUrl */ .Z.stringifyUrl({
        url: "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier),
        query: {
            lng: locale,
            locations: type === "location" ? id : undefined,
            op: type === "provider" ? "~".concat(id) : type === "service" ? "".concat(id, "~") : undefined
        }
    });
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>{
    return "/b/".concat(path);
};
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    return truncateString(label, limit);
};
function sortListByAnotherList(unsortedList, sortedList) {
    let key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "id";
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(unsortedList) || (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(sortedList)) {
        return unsortedList;
    }
    const indexedUnsortedList = (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(unsortedList, key);
    if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(sortedList[0])) {
        const diff = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(unsortedList, (item)=>item && item[key]), sortedList);
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            ...sortedList,
            ...diff
        ], (key)=>indexedUnsortedList[key]));
    } else {
        const diff1 = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(unsortedList, sortedList, key);
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            ...sortedList,
            ...diff1
        ], (item)=>indexedUnsortedList[item[key]]));
    }
}



/***/ })

}]);